export default {
  Request: 1,
  Success: 2,
  Failure: 3,
};
